<template>
    <div id="mensajes">
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="18" class="titulo">
                Mensajes de la Comision # {{ idComision }}<br>
                <small>{{ Nombre }}</small>
            </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="22" class="cuerpo">
                <el-tabs v-model="ActiveTab">


                    <!-- Recibidos -->
                    <el-tab-pane name="tab1" label="Recibidos">
                        <el-table :data="Recibidos" border style="width:100%">
                            <el-table-column
                                prop="Capacitador"
                                label="Remitente">
                            </el-table-column>
                            <el-table-column
                                label="Asunto">
                                <template slot-scope="scope">
                                    {{ scope.row.titulo }}
                                    &nbsp;
                                    <span v-if="scope.row.leido==0" style="color:#f00">
                                        <i class="el-icon-message"></i>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="fecha"
                                label="Fecha">
                            </el-table-column>
                            <el-table-column
                                label="Ver">
                                <template slot-scope="scope">
                                    <center><router-link :to="'/mensaje/' + scope.row.idEncriptado + ''" class="el-button el-button--success el-button--mini">Ver</router-link></center>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="Responder">
                                <template slot-scope="scope">
                                    <center><el-button type="success" class="el-button--mini" v-if="comisionabierta" @click="Responder(scope.row.id, scope.row.titulo)">Responder</el-button></center>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>


                    <!-- Enviados -->
                    <el-tab-pane name="tab2" label="Enviados">
                        <el-table :data="Enviados" border style="width:100%">
                            <el-table-column
                                prop="Capacitador"
                                label="Destinatario">
                            </el-table-column>
                            <el-table-column
                                prop="titulo"
                                label="Asunto">
                            </el-table-column>
                            <el-table-column
                                prop="fecha"
                                label="Fecha">
                            </el-table-column>
                            <el-table-column
                                label="Ver">
                                <template slot-scope="scope">
                                    <center><router-link :to="'/mensaje/' + scope.row.idEncriptado + ''" class="el-button el-button--success el-button--mini">Ver</router-link></center>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>


                    <!-- Escribir Mensaje -->
                    <el-tab-pane name="tab3" label="Escribir Mensaje" v-if="comisionabierta">
                        <el-form ref="f" :model="model" :rules="rules">

                            <v-alert v-if="exito" type="success" color="green" :value="true">
                                El mensaje fue enviado correctamente.
                            </v-alert>
                            <v-alert v-if="error" type="error" color="red" :value="true">
                                Ha ocurrido un error. Por favor, intente nuevamente.
                            </v-alert>

                            <el-form-item label="Asunto" prop="asunto">
                                <el-input v-model="model.asunto" placeholder="Asunto" required @keypress.native="control($event, 't')"></el-input>
                            </el-form-item>
                            <el-form-item label="Mensaje" prop="mensaje">
                                <el-input type="textarea" :rows="5" v-model="model.mensaje" placeholder="Ingrese su texto aquí..." required></el-input>
                            </el-form-item>
                            <el-row :gutter="20" type="flex" justify="center" style="margin-top:50px">
                                <el-col :xs="24" :sm="12" :md="8">
                                    <v-btn 
                                        raised 
                                        block
                                        color="blue" 
                                        :loading="cargando" 
                                        @click="MsjSubmit('f')"
                                        style="color:#fff"
                                    >
                                        Enviar
                                    </v-btn>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>


                <el-row :gutter="20" type="flex" justify="center" style="margin-top:30px">
                    <el-col :xs="24" :sm="12" :md="8">
                        <router-link class="el-col el-col-24 el-button el-button--danger"
                        :to="{ name: 'capacitacion', params: { idComisionEncriptada } }">
                            Volver
                        </router-link>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>



<script>
    import axios from 'axios';

    export default
    {   data()
        {   return {
                idComisionEncriptada:   this.$route.params.id,
                idComision:             atob(this.$route.params.id),
                model:                  [],
                Enviados:               [],
                Recibidos:              [],
                ActiveTab:              'tab1',
                Nombre:                 '',
                cargando:               false,
                comisionabierta:        false,
                exito:                  false,
                error:                  false,

                rules: {
                    asunto: [
                        { required: true, message: 'Por favor, ingrese el Asunto del Mensaje', trigger: 'blur' }
                    ],
                    mensaje: [
                        { required: true, message: 'Por favor, ingrese su Mensaje', trigger: 'blur' }
                    ]
                }

            }
        },


        methods:
        {   control(e, tipo)
            {   if(tipo=='t')
                {   if( (e.which>32  && e.which<65)  ||
                        (e.which>90  && e.which<97)  ||
                        (e.which>123 && e.which<209) ||
                        (e.which>209 && e.which<241) ||
                        (e.which>241)
                    )
                    { e.preventDefault(); }                                                 // Campo alfabetico
                }
            },
            Responder(idMensaje, asunto)
            {   this.model.respuesta                = idMensaje;
                this.model.asunto                   = 'RE: ' + asunto;
                this.ActiveTab                      = 'tab3';
            },
            MsjSubmit()
            {   this.cargando   = true;
                var params      = '';
                var headers     = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');

                params  = params + '&tkn=' + this.$cookies.get('PDTK');
                params  = params + '&idComision=' + btoa(this.idComision);
                params  = params + '&idRespuesta=' + btoa(this.model.respuesta);
                params  = params + '&Asunto=' + this.model.asunto;
                params  = params + '&Mensaje=' + this.model.mensaje;
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/com_msj_in.php', params, {headers: headers})
                    .then(response => {
                        const datos                 = response.data
                        this.exito                  = datos['exito'];
                        this.error                  = datos['error'];
                        this.Enviados               = datos['enviados'];
                        this.model.asunto           = '';
                        this.model.mensaje          = '';
                        this.cargando               = false;
                    })
                    .catch(e => {
                        this.exito                  = false;
                        this.error                  = true;
                    })

            }
        },


        beforeMount()
        {   if(!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
            else
            {   var params  = '';
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');

                params  = params + '&tkn=' + this.$cookies.get('PDTK');
                params  = params + '&idComision=' + btoa(this.idComision);
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/com_msjs.php', params, {headers: headers})
                    .then(response => {
                        const datos                 = response.data;
                        if(datos['comision'])
                        {   this.Enviados           = datos['enviados'];
                            this.Recibidos          = datos['recibidos'];
                            this.Nombre             = datos['comision'];
                            this.comisionabierta    = datos['comisionabierta'];
                            this.model.respuesta    = '0';
                        }
                        else
                        {   this.$router.push('../capacitaciones');
                        }
                    })
                   /* .catch(e => {})*/
            }
        }
    };
</script>



<style>
    .el-tabs__item
    {   font-weight: bold;
    }

    tr th 
    {   background: #EEF1F6 !important;
    }
</style>
